import { FirebaseUserModel } from "../core/user.model";

export class Session {
  public token: string;
  public user: FirebaseUserModel;
  public DB: any;
  public uid: string;
  public photoUrl: string;
  public displayName: string;
}